import React, { useEffect, useState } from "react";
import { fetchActionsUtil, statusColor, useCookie } from "../../utils";
import { URLS } from "../urls";
import ModalLoader from "../ModalLoader";
import {  CalendarTodayOutlined } from "@mui/icons-material";
import moment from "moment";
import NoTableItem from "../NoTableItem";
import TableComponent from "../TableComponent";

const AttendanceHistory = ({ eId }) => {
  const token = useCookie("token");

  const [state, setState] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);

      const endDate = moment(); // today
      const startDate = moment().subtract(1, "years"); 

      const attendanceData = fetchActionsUtil(
        `${
          URLS.backendattendance
        }/getByUserId/${eId}?userEmployeeId=${true}&startDate=${startDate}&endDate=${endDate}`,
        "GET",
        token
      );

      const [attendanceResult] = await Promise.all([attendanceData]);


      setState(attendanceResult.attendance);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchData();
    }

    return () => {
      isMounted = false;
    };
  }, []);


  
    const tableHead = () => {
      return (
        <thead className="table">
          <tr>
           
            <th>No</th>
            <th>Employee Name </th>
            <th>Employee ID </th>
            <th>Date </th>
            <th>In-Time</th>
            <th>Out-Time</th>
            <th>Result</th>
            <th>Source</th>
          </tr>
        </thead>
      );
    };

    const tableBodyData = (attendance, index) => {
      return (
        <>     
          <td>{index + 1}</td>
          <td>{attendance.Name}</td>
          <td>{attendance.ID}</td>
          <td className="d-flex gap-3 align-items-center">
            {" "}
            <span>
              {" "}
              <CalendarTodayOutlined fontSize="small" />{" "}
            </span>{" "}
            <p>{moment(attendance?.Date)?.format("MMMM Do YYYY")}</p>{" "}
          </td>
          <td>{attendance.in}</td>
          <td>{attendance.out}</td>
          <td>
            <p
              className={`tw-status ${statusColor(
                ["No SignOut", "Early Closure", "Late", "Absent"].includes(
                  attendance.result
                )
                  ? "red"
                  : attendance.result === "Good"
                  ? "green"
                  : attendance.result === "OnLeave"
                  ? "orange"
                  : "blue"
              )}`}
            >
              {attendance.result}
            </p>
          </td>
          <td>{attendance?.uploadType}</td>
        </>
      );
    };

  return (
    <div>

      <div className="row">
        <div className="col-md-12">


          <div className="mt-4">
            {/*<!-- JobGradeHistory Table -->*/}
            <div className="info">
              <div className="table-height">
                {state?.length > 0 ? (
                  <TableComponent
                    responsive
                    borderless
                    // striped
                    sticky
                    // hover
                    tableHeadsFunction={tableHead}
                    mainDataArray={state}
                    tableDataRowFunction={tableBodyData}
                    className="product-table text-nowrap"
                    // onDoubleClickRow={onRowClick}
                  />
                ) : (
                  <NoTableItem />
                )}
              </div>
            </div>
            {/*<!-- Table --> */}
          </div>
        </div>
      </div>
      <ModalLoader show={isLoading} />
    </div>
  );
};

export default AttendanceHistory;
